import { pastelPalette } from '../constants/color.constants';

export const getColorForIndex = index => {
  return pastelPalette[index % pastelPalette.length];
};

export const RandomCard = ({ children, displayType, userColor, widget }) => {
  const primaryColor = getComputedStyle(document.documentElement)
    .getPropertyValue('--primary-color')
    .trim();
  const color = userColor ? userColor : primaryColor;

  const hexToRgb = inputColor => {
    if (inputColor.startsWith('#')) {
      const hex = inputColor.replace('#', '');
      return [
        parseInt(hex.slice(0, 2), 16),
        parseInt(hex.slice(2, 4), 16),
        parseInt(hex.slice(4, 6), 16),
      ];
    }
    if (/^[0-9a-fA-F]{6}$/.test(inputColor)) {
      return [
        parseInt(inputColor.slice(0, 2), 16),
        parseInt(inputColor.slice(2, 4), 16),
        parseInt(inputColor.slice(4, 6), 16),
      ];
    }
    if (inputColor.startsWith('rgb')) {
      return inputColor.match(/\d+/g).slice(0, 3).map(Number);
    }

    return [130, 214, 231];
  };

  const rgb = hexToRgb(color);
  const cardAccentColor = widget?.custom_properties?.widget_accent_color
    ? widget.custom_properties.widget_accent_color
    : color;
  const rgbAccent = hexToRgb(cardAccentColor);

  const cardModeStyles = (() => {
    switch (displayType) {
      case 'card':
        return {
          background: `linear-gradient(
                135deg,
                rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 0.9),
                rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 0.05)
              )`,
          border: `1px solid rgba(${rgbAccent[0]}, ${rgbAccent[1]}, ${rgbAccent[2]}, 0.35)`,

          boxShadow: `0 4px 12px rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 0.25)`,
        };

      case 'external-link-button':
        return {
          background: `
    linear-gradient(
      135deg,
      rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 0.9),
      rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 0.05)
    )
  `,

          boxShadow: `0 4px 8px rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 0.3)`,
          cursor: 'pointer',
          textAlign: 'center',
          fontWeight: 600,

          transition: 'all 0.2s ease-in-out',
        };

      default:
        return {
          border: `1px solid rgba(${rgbAccent[0]}, ${rgbAccent[1]}, ${rgbAccent[2]}, 0.35)`,
        };
    }
  })();
  const lighten = (v, amt = 20) => Math.min(255, v + amt);

  return (
    <div
      className={`relative shadow-5 relative flex flex-column random-card z-2 border-round-lg ${displayType !== 'external-link-button' ? 'p-2' : ''}`}
      style={{
        border: `1px solid ${color}`,
        overflow: 'hidden',
        ...cardModeStyles,
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '-30px',
          right: '-30px',
          width: '70px',
          height: '70px',
          borderRadius: '50%',
          opacity: 0.75,
          pointerEvents: 'none',
          zIndex: 999,
          background: `linear-gradient(
      135deg,
      rgba(
        ${lighten(rgbAccent[0])},
        ${lighten(rgbAccent[1])},
        ${lighten(rgbAccent[2])},
        0.9
      ),
      rgba(
        ${rgbAccent[0]},
        ${rgbAccent[1]},
        ${rgbAccent[2]},
        0.9
      )
    )`,
        }}
      />

      <div
        className={`${displayType === 'table-report' ? 'flex p-2' : displayType === 'external-link-button' ? 'flex align-items-center' : ''} h-full`}
      >
        {children}
      </div>
    </div>
  );
};
